export default "__VITE_ASSET__YOCu3xjb__"